import types, { IAction } from '../../types/actions';
import { UnitEnum } from '../products/product.reducet';

export interface IProductItem {
	allergens: string;
	barCode: null;
	code: string;
	composition: string;
	createdAt: number;
	description: string;
	diet: string;
	enabled: boolean;
	id: number;
	image: string;
	name: string;
	nutritionalValues: string;
	price: string;
	storeAt: null;
	unit: UnitEnum;
	uuid: string;
}

export interface IFilterNode {
	code: string;
	createdAt: number;
	enabled: boolean;
	id: number;
	image: string;
	name: string;
	product: IProductItem;
	section?: IFilterNode;
	uuid: string;
}

export interface IFilterState {
	fetchFilter: string;
	filterData?: IFilterNode[];
	filterSearchItem?: string;
}

const initialState: IFilterState = {
	fetchFilter: '',
	filterSearchItem: undefined,
	filterData: undefined,
};

export const filterReducer = (state = initialState, action: IAction) => {
	switch (action.type) {
		case types.GET_ALL_PRODUCTS_FAILURE: {
			return {
				...state,
				fetchFilter: 'FAILURE',
			};
		}
		case types.SET_FILTER_SEARCH_ITEM: {
			return {
				...state,
				filterSearchItem: action.payload,
			};
		}
		default:
			return state;
	}
};
